export type Eye = 'RIGHT' | 'LEFT'

export const RIGHT_EYE: Eye = 'RIGHT'
export const LEFT_EYE: Eye = 'LEFT'

export const EYES = [RIGHT_EYE, LEFT_EYE] // this is the preferred order

/** Which eye is amblyopic, left or right? */
export type AmblyopicEye = Eye



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/prescription/eye.ts